<template>
  <div>
    <div @click="closeModal" class="modal">
      <div class="modal-wrap">
        <h2>Create Sub Category</h2>
        <form @submit.prevent="createSubCategory" action>
          <div class="input-field">
            <label for="categroyName">Category Name</label>
            <input
              v-model="categoryName"
              type="text"
              id="categroyName"
              placeholder
            />
          </div>
          <button class="btn purple">Create Category</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import db, { timestamp } from "../../firebase/init";
export default {
  name: "CreateSubCategory",
  props: ["createCategoryModal", "id", "categoryId"],
  data() {
    return {
      categoryName: "",
    };
  },
  methods: {
    closeModal(e) {
      // sends a signal if the target clicked is not the modal wrap
      const modal = document.querySelector(".modal");
      if (e.target === modal) {
        this.$emit("close-modal");
      }
    },

    createSubCategory() {
      const ref = db.collection("category").doc(this.categoryId);
      const increment = firebase.firestore.FieldValue.increment(1);
      if (this.categoryName.length === 0) {
        alert("Field cannot be empty");
      } else {
        db.collection("subCategory")
          .doc()
          .set({
            categoryId: this.categoryId,
            name: this.categoryName,
            date: timestamp(),
            createdBy: this.id,
            items: 0,
          })
          .then(() => {
            ref.update({
              items: increment,
            });
            this.$emit("close-modal");
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.479);
  top: 0;
  z-index: 99;
  height: 100%;
  width: 100%;

  .modal-wrap {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    width: 500px;
    height: 300px;
    padding: 2rem;
    background-color: white;
  }

  .input-field {
    margin: 1rem 0;
    display: flex;
    flex-direction: column;
  }

  label {
    font-size: 12px;
    font-weight: 400;
  }

  input {
    font-size: 14px;
    border: none;
    border-bottom: 1px solid #979797;
    margin-top: 0.5rem;
    padding: 0.7rem 4px;
    transition: 500ms ease all;

    &:focus {
      outline: none;
      box-shadow: 0 1px 0 0 #6236ff;
      border-color: #6236ff;
    }
  }

  form {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .btn {
    margin-top: auto;
  }
}
</style>
